import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import configData from "../../../temp/config";
import SearchTypeDropdown from "./SearchTypeDropdown";
import { isMobile } from "react-device-detect";
import "./search-name.css";
import { Placeholder } from "@sitecore-jss/sitecore-jss-react";
import GenderFilter from "../filters/GenderFilter";
import OriginFlter from "../filters/OriginFlter";

const defaultsearchtext = "";

const FirstNameForm = (props) => {
  const { t } = props;

  const [searchString, setSearchString] = useState(
    sessionStorage.getItem("FirstTab_PreviousSearchTerm")
  );
  const [btnactive, setBtnactive] = useState(true);
  const [clsstate, setClsstate] = useState("");
  const [showclose, setShowclose] = useState(false);
  const [searchType, setSearchType] = useState("searchbyname");
  const [placeHolderText, setPlaceHolderText] = useState("");
  const [showAutoNames, setShowAutoNames] = useState(false);
  // const [genderFilterList, setGenderFilterList] = useState([])
  // const [counter, setCounter] = useState(0)

  useEffect(() => {
    setSearchString("");
    setClsstate("");
    setShowclose(false);
    setBtnactive(true);
    if (props.tabData.data.key.value === "MIDDLE_NAME") {
      setPlaceHolderText(
        props.tabData.data.searchTypes[0].fields.placeholderText.value
      );
      setSearchType(props.tabData.data.searchTypes[0].fields.key.value);
      props.getSearchType(props.tabData.data.searchTypes[0].fields);
    }   
    // sessionStorage.setItem('genderFilterList', JSON.stringify([]))
  }, [searchType]);

  const selectNamefromAutoSuggest = (name) => {
    console.log(name);
    AutoSuggestItemsSearch(name);
    setBtnactive(false);
    setSearchString(name);
    setShowAutoNames(false);
    setShowclose(true);
  };

  const AutoSuggestItemsSearch = (itemName) => {
    props.getSearchText(itemName);
    setClsstate("active");
    setShowclose(true);
    // showclose(true)
    setShowAutoNames(false);
  };

  const [showWarningMessage, setWarningMessage] = useState(false);

  const handleChange = (e) => {
    if (searchType === "searchbyalphabet") {
      if (e.target.value.length > 1) e.preventDefault();
      else {
        setClsstate("");
        setShowclose(false);
        if (e.target.value.length !== 0) {
          setBtnactive(false);
          sessionStorage.setItem("searchText", e.target.value);
          setSearchString(e.target.value);
        } else {
          setBtnactive(true);
          sessionStorage.setItem("searchText", defaultsearchtext);
          setSearchString(defaultsearchtext);
          //props.getSearchText(defaultsearchtext)
        }
      }
    } else if (searchType === "searchbyyear") {
      if (e.target.value.length > 4) e.preventDefault();
      else {
        setClsstate("");
        setShowclose(false);
        if (e.target.value.length !== 0) {
          setBtnactive(false);
          sessionStorage.setItem("searchText", e.target.value);
          setSearchString(e.target.value);
        } else {
          setBtnactive(true);
          sessionStorage.setItem("searchText", defaultsearchtext);
          setSearchString(defaultsearchtext);
          //props.getSearchText(defaultsearchtext)
        }
      }
    } else if (searchType === "searchbymeaning") {
      if (e.target.value.length < 1) {
        setClsstate("");
        setShowclose(false);
        setBtnactive(true);
        sessionStorage.setItem("searchText", e.target.value);
        setSearchString(e.target.value);
        setShowAutoNames(false);
      } else if (e.target.value.length > 50) e.preventDefault();
      else {
        setClsstate("");
        setShowclose(false);
        if (e.target.value.length !== 0) {
          setBtnactive(false);
          sessionStorage.setItem("searchText", e.target.value);
          setSearchString(e.target.value);
        } else {
          setBtnactive(true);
          sessionStorage.setItem("searchText", defaultsearchtext);
          setSearchString(defaultsearchtext);
          //props.getSearchText(defaultsearchtext)
        }
        setShowAutoNames(false);
      }
    } else if (searchType === "searchformiddlenames") {
      if (e.target.value.length < 3) {
        setClsstate("");
        setShowclose(false);
        setBtnactive(true);
        sessionStorage.setItem("searchText", e.target.value);
        setSearchString(e.target.value);
        setShowAutoNames(false);
      } else if (
        searchType === "searchformiddlenames" &&
        e.target.value.length > 2 &&
        e.target.value.length < 11
      ) {
        setBtnactive(false);
        props.getAutoSuggestNames(e.target.value);
        sessionStorage.setItem("searchText", e.target.value);
        setSearchString(e.target.value);
        setShowAutoNames(true);
      } else if (e.target.value.length > 50) e.preventDefault();
      else {
        setClsstate("");
        setShowclose(false);
        if (e.target.value.length !== 0) {
          setBtnactive(false);
          sessionStorage.setItem("searchText", e.target.value);
          setSearchString(e.target.value);
        } else {
          setBtnactive(true);
          sessionStorage.setItem("searchText", defaultsearchtext);
          setSearchString(defaultsearchtext);
          //props.getSearchText(defaultsearchtext)
        }
        setShowAutoNames(false);
      }
    } else if (searchType === "searchbyname") {
      // setShowAutoNames(false)
      if (e.target.value.length < 2) {
        setClsstate("");
        setShowclose(false);
        setEnableCloseButton(false)
        setBtnactive(true);
        setSearchString(e.target.value);
        sessionStorage.setItem("searchText", e.target.value);
        setShowAutoNames(false);
        if (e.target.value.length === 0) {
          setWarningMessage(false);
        } else {
          setWarningMessage(true);
        }
      } else if (e.target.value.length > 1 && e.target.value.length < 11) {
        setBtnactive(false);
        props.getAutoSuggestNames(e.target.value);
        setSearchString(e.target.value);
        sessionStorage.setItem("searchText", e.target.value);
        setShowAutoNames(true);
        setWarningMessage(false);
      } else if (e.target.value.length > 50) e.preventDefault();
      else {
        setClsstate("");
        setShowclose(false);
        if (e.target.value.length !== 0) {
          setBtnactive(false);
          setSearchString(e.target.value);
          sessionStorage.setItem("searchText", e.target.value);
        } else {
          setBtnactive(true);
          setSearchString(defaultsearchtext);
          sessionStorage.setItem("searchText", defaultsearchtext);
          //props.getSearchText(defaultsearchtext)
        }
        setShowAutoNames(false);
      }
    } else {
      setClsstate("");
      setShowclose(false);
      if (e.target.value.length !== 0) {
        setBtnactive(false);
        sessionStorage.setItem("searchText", e.target.value);
        setSearchString(e.target.value);
      } else {
        setBtnactive(true);
        sessionStorage.setItem("searchText", defaultsearchtext);
        setSearchString(defaultsearchtext);
        //props.getSearchText(defaultsearchtext)
      }
    }
  };
  const handleClick = (e) => {
    e.preventDefault();
    sessionStorage.setItem("currentPage", 1);
    if (!btnactive) {
      if (
        searchType === "searchbyyear" &&
        Number(e.target.value) >
          Number(t("BabyNameFinder_SearchByYearInputMaxValue"))
      ) {
        // setSearchString(Number(t('BabyNameFinder_SearchByYearInputMaxValue')))
        props.getSearchText(
          Number(e.target.value),
          Number(t("BabyNameFinder_SearchByYearInputMaxValue"))
        );
      } else if (
        searchType === "searchbyyear" &&
        Number(e.target.value) <
          Number(t("BabyNameFinder_SearchByYearInputMinValue"))
      ) {
        // setSearchString(Number(t('BabyNameFinder_SearchByYearInputMinValue')))
        props.getSearchText(
          Number(e.target.value),
          Number(t("BabyNameFinder_SearchByYearInputMinValue"))
        );
      } else {
        props.getSearchText(searchString);
      }

      setClsstate("active");
      setShowclose(true);
    }

    setShowAutoNames(false);
  };

  const handleClose = (e) => {
    e.preventDefault();
    sessionStorage.setItem("currentPage", 1);
    setSearchString(defaultsearchtext);
    props.getSearchText(defaultsearchtext);
    setShowclose(false);
    setClsstate(defaultsearchtext);
    setBtnactive(true);
    props.clearTextWithResult();
    sessionStorage.setItem("enableCloseButton", false);
    setShowAutoNames(false);
  };

  const [enableCloseButton, setEnableCloseButton] = useState(false);

  useEffect(() => {
    setEnableCloseButton(sessionStorage.getItem("enableCloseButton") === 'true');
  });

  const restrictSpecialChar = (e) => {
    var key = e.keyCode ? e.keyCode : e.which;
    if (key === 13) handleClick(e);
    if (
      !(
        key == 39 ||
        (key >= 44 && key <= 46) ||
        (key >= 48 && key <= 57) ||
        (key >= 58 && key <= 59) ||
        (key >= 65 && key <= 90) ||
        (key >= 97 && key <= 122)
      ) &&
      key != 8 &&
      key != 32
    )
      e.preventDefault();
    if (searchType === "searchbyname") {
      if (key == 32) e.preventDefault();
    }
    if (searchType === "searchbymeaning") {
      if (key == 39 || (key >= 44 && key <= 46) || (key >= 58 && key <= 59))
        e.preventDefault();
    }
    if (searchType === "searchbyyear") {
      if (key > 31 && (key < 48 || key > 57)) e.preventDefault();
    }
    if (searchType === "searchbyalphabet") {
      if (searchType === "searchbyalphabet") {
        if (
          key == 39 ||
          (key >= 44 && key <= 46) ||
          (key >= 48 && key <= 59) ||
          key == 32
        )
          e.preventDefault();
      }
    }
  };

  const getSearchType = (searchtype) => {
    setSearchType(searchtype.key.value);
    setPlaceHolderText(searchtype.placeholderText.value);
    props.getSearchType(searchtype);
    setShowAutoNames(false);
    // console.log(searchtype);
  };

  const paginate = (pagenumber) => {
    props.paginate(pagenumber);
  };

  return (
    <>
      <div className="babyNameSearchByWrapper">
        {props.tabData.data.key.value === "MIDDLE_NAME" && isMobile && (
          <p className="nameSearchFieldHeading">
            {props.componentData.searchByLabel.value}
          </p>
        )}
        {props.tabData.data.key.value !== "MIDDLE_NAME" && (
          <div className="mobile-search-by-name">
            {isMobile && (
              <p className="nameSearchFieldHeading">
                {props.componentData.searchByLabel.value}
              </p>
            )}
            <SearchTypeDropdown
              searchTypes={props.tabData.data.searchTypes}
              getSearchType={getSearchType}
              paginate={paginate}
              setWarningMessage={setWarningMessage}
            />
          </div>
        )}
        <div className="formfields formfields-babyNameFinder">
          <div className={`fields fields-${clsstate}`}>
            <form
              role="search"
              id="searchform"
              className="searchform"
              onSubmit={handleClick}
            >
              <div className="searchfield">
                {showWarningMessage && (
                  <div className="searchFieldWarning arrow-bottom">
                    {t("BabyNameFinder_SearchByNameWarningMessage")}
                  </div>
                )}
                <input
                  type="text"
                  value={searchString}
                  onChange={(e) => handleChange(e)}
                  onKeyPress={restrictSpecialChar}
                  placeholder={placeHolderText}
                />
                <button className="btn" type="submit" disabled={btnactive}>
                  {!showclose && !enableCloseButton ? (
                    <i
                      className="fa fa-search"
                      onClick={(e) => handleClick(e)}
                      aria-hidden="true"
                    />
                  ) : (
                    <i
                      className="fa fa-times"
                      onClick={(e) => handleClose(e)}
                      aria-hidden="true"
                    />
                  )}
                </button>
              </div>
            </form>
          </div>
          {showAutoNames && (
            <div
              className={
                props.autoNames.length > 0
                  ? "searchByEnterKey"
                  : "searchByEnterKey remove-border"
              }
            >
              {props.autoNames &&
                props.autoNames.map((item, index) => {
                  if (index < 5) {
                    return (
                      <p
                        className="searchByEnterKeyName"
                        key={index + item}
                        onClick={() => selectNamefromAutoSuggest(item)}
                      >
                        {item}
                      </p>
                    );
                  }
                })}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default withTranslation()(FirstNameForm);
